<script>
  export let value;

  $: ({ left, top, width, height } = value);
</script>

<div class="font-mono">
  ({left},{top},{width},{height})
</div>
